export const clearLocalStorageOnLogout = () => {
    localStorage.setItem('forced-logout', 'false');
    localStorage.removeItem('forced-logout-reason');
};
